import type { ObservableDocument } from './observable-document.type.ts';
import type { NsldsStructuredContent } from './observable-document.type';

export interface ObservableDocumentExtension extends ObservableDocument {}
export class ObservableDocumentExtension {
  // ── Computed ──
  get nsldsSummary() {
    if (this.provider === 'ObservableProvider.NSLDS') {
      const content = this.structuredContent as NsldsStructuredContent;
      return {
        fileRequestDate: content.file.file_request_date,
        student: {
          firstName: content.student.student_first_name,
          middleInitial: content.student.student_middle_initial,
          lastName: content.student.student_last_name,
          totalAllGrants: parseFloat(content.student.student_total_all_grants),
          totalAllLoansOutstandingPrincipal: parseFloat(
            content.student.student_total_all_loans_outstanding_principal
          ),
          totalAllLoansOutstandingInterest: parseFloat(
            content.student.student_total_all_loans_outstanding_interest
          ),
        },
        loanTotal: content.loans.length,
      };
    }
  }
}

const Registration = {
  kind: 'object',
  name: 'observable-document',
  features: ObservableDocumentExtension,
};
export default Registration;
